import {gql, useMutation} from '@apollo/client';
import {Pda} from './components/Pda';
import {Header} from './components/Header';
import { ArrivalRelatedScanComponent, HandleScanEventResult } from './components/ArrivalRelatedScanComponent';
import { t } from '../../i18n';


const HANDLE_WHS_TRANSFER_ARRIVAL_SCAN_EVENT = gql`
   mutation HandleWhsTransferArrivalScanEvent($barCode: String!) {
     success: handleWhsTransferArrivalScanEvent(barCode: $barCode)
   }
` 

const PageBody = () => {
    const [handleWhsTransferArrivalScanEvent] = useMutation<HandleScanEventResult>(HANDLE_WHS_TRANSFER_ARRIVAL_SCAN_EVENT);

    const handleScanEvent = async (barCode: string): Promise<HandleScanEventResult> => {
        const {data} = await handleWhsTransferArrivalScanEvent({ variables: { barCode } });
        return {success: data?.success || false};
    };
    return (
        <ArrivalRelatedScanComponent
         value1Placeholder={t('pda.pages.transferArrival.bagCodeTrackingNo')} 
         value1ColumnTitle={t('pda.common.bagPackage')} 
         handleScanEvent={handleScanEvent} />
    );
}

export default function TransferArrivalPage() {
    return (
        <div className="w-full h-full flex flex-col gap-2 p-2">
            <Header title={t('pda.pages.transferArrival.transferArrivalScan')}/>
            <Pda/>
            <PageBody/>
        </div>
    );
}